export const API_CONFIG = {
  // 翻译API
  TRANSLATE_API: import.meta.env.PROD
    ? 'https://tl.whoops.space'  // 生产环境
    : '/translate', // 开发环境

  // Jotoba API 基础地址
  JOTOBA_API: import.meta.env.VITE_APP_JOTOBA_API || 'https://jotoba.de',

  // Jotoba API 端点配置 - 根据环境区分代理和直接访问
  JOTOBA_API_ENDPOINT: import.meta.env.PROD
    ? 'https://jotoba.de/api/search/words'  // 生产环境直接访问
    : '/api/jotoba/api/search/words',       // 开发环境通过代理

  // 罗马音转换API
  ROMAJI_API: import.meta.env.PROD
    ? 'https://api.romaji2kana.com'
    : '/api/romaji',

  // 修改 KUROMOJI_DICT_PATH 确保使用绝对 URL
  KUROMOJI_DICT_PATH: import.meta.env.VITE_APP_KUROMOJI_DICT_PATH,
};